const colorConfig = {
  bus: ['#F0008C', '#B00468'],
}

export const defaultColors = ['#1A1919', '#575757']
export const selectedStrokeColor = '#FFFFFF'
export default colorConfig
